import { useLanguage } from "@/context/LanguageContext";

export default function About() {
  const { t } = useLanguage();
  return (
    <div className="pt-32 pb-24">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="overline mb-3">{t("about.label")}</div>
        <h1 className="font-serif text-5xl md:text-7xl leading-[1.02] tracking-tight text-ink font-light max-w-4xl">
          {t("about_section.quiet")}
        </h1>

        <div className="mt-16 grid md:grid-cols-12 gap-12">
          <div className="md:col-span-6">
            <img
              src="https://images.unsplash.com/photo-1613490493576-7fde63acd811?auto=format&fit=crop&w=1800&q=80"
              alt=""
              className="w-full aspect-[4/5] object-cover"
            />
          </div>
          <div className="md:col-span-6 space-y-6 text-lg text-ink leading-relaxed font-normal">
            <p>{t("about.body_a")}</p>
            <p>{t("about.body_b")}</p>
            <div className="hairline my-8" />
            <div className="grid grid-cols-2 gap-8">
              <Stat value="14+" label={t("about_section.years")} />
              <Stat value="€380M+" label={t("about_section.volume")} />
              <Stat value="4" label={t("about_section.languages")} />
              <Stat value="100%" label={t("about_section.referral")} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function Stat({ value, label }) {
  return (
    <div>
      <div className="font-mono text-3xl text-ink">{value}</div>
      <div className="overline mt-2">{label}</div>
    </div>
  );
}
